const companyFields = {
  cardSurcharge: 86,
  automaticCardSurcharge: 140,
  automaticApproveDepositsFromSale: 143,
  useIngredientsCost: 145,
  seeMeasureUnit: 146,
  useDraftPurchases: 148,
  useDraftExpenses: 149,
  useExportationInvoice: 151,
}

export const companyFieldsSell = {
  canChangeInventoryReturnOptionByCompany: 142,
  useDraftSale: 144,
  enabledZeroPrices: 147,
  experimentalConfirmSale: 152,
}

export const companyFieldsInvoice = {
  automaticFEL: 117,
}

export default companyFields
